import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { formatRupiah, formatDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { BellRing, ChevronRight, MessageCircle } from "lucide-react";

const waPhone = (p) => { const d = (p || "").replace(/\D/g, ""); return d.startsWith("0") ? `62${d.slice(1)}` : d.startsWith("8") ? `62${d}` : d; };
const waLink = (t) => {
  const when = t.days_left < 0 ? `telah jatuh tempo pada ${formatDate(t.due_date)}` : `akan jatuh tempo pada ${formatDate(t.due_date)}`;
  const msg = `Halo Bapak/Ibu ${t.customer_name}, kami dari EXTRA TRUSS ingin mengingatkan tagihan nota ${t.nota_number} dengan sisa ${formatRupiah(t.remaining)} yang ${when}. Mohon dapat segera diselesaikan. Terima kasih.`;
  return `https://wa.me/${waPhone(t.customer_phone)}?text=${encodeURIComponent(msg)}`;
};

const dueLabel = (d) => (d < 0 ? `Terlambat ${-d} hari` : d === 0 ? "Jatuh tempo hari ini" : `${d} hari lagi`);

export function ReceivablesDuePanel() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/receivables/due-soon").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;

  return (
    <Card className="p-4 border-amber-300" data-testid="receivables-due-panel">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <BellRing className="h-4 w-4 text-amber-600" />
          <h3 className="font-semibold" style={{ fontFamily: "Outfit" }}>Piutang Jatuh Tempo Minggu Ini</h3>
          {data.overdue > 0 && <span className="text-[11px] font-semibold rounded-full bg-rose-100 text-rose-700 px-2 py-0.5" data-testid="receivables-due-overdue">{data.overdue} terlambat</span>}
        </div>
        <button onClick={() => navigate("/receivables")} className="text-xs text-brand hover:underline flex items-center gap-1" data-testid="receivables-due-see-all">
          Total <span className="font-mono font-semibold" data-testid="receivables-due-total">{formatRupiah(data.total)}</span> <ChevronRight className="h-3.5 w-3.5" />
        </button>
      </div>
      {data.rows.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="receivables-due-empty">Tidak ada piutang yang jatuh tempo dalam 7 hari ke depan.</p>
      ) : (
        <div className="divide-y">
          {data.rows.slice(0, 6).map((t) => (
            <div key={t.id} onClick={() => navigate(`/transactions/${t.id}`)} data-testid={`receivables-due-row-${t.id}`}
              className="w-full flex items-center justify-between gap-3 py-2 text-left hover:bg-secondary/50 px-1 rounded cursor-pointer">
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">{t.customer_name} <span className="font-mono text-xs text-muted-foreground">· {t.nota_number}</span></p>
                <p className={`text-[11px] ${t.days_left < 0 ? "text-rose-600 font-semibold" : "text-amber-700"}`}>{formatDate(t.due_date)} · {dueLabel(t.days_left)}</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="font-mono text-sm font-semibold">{formatRupiah(t.remaining)}</span>
                {waPhone(t.customer_phone).length >= 9 ? (
                  <a href={waLink(t)} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} title="Kirim pengingat via WhatsApp"
                    className="inline-flex items-center gap-1 rounded-md bg-[#25D366] hover:bg-[#1ebe5b] text-white text-xs font-semibold px-2 py-1 transition-colors" data-testid={`receivables-due-wa-${t.id}`}>
                    <MessageCircle className="h-3.5 w-3.5" /> <span className="hidden sm:inline">WhatsApp</span>
                  </a>
                ) : (
                  <span className="text-[10px] text-muted-foreground" data-testid={`receivables-due-nophone-${t.id}`}>No. HP kosong</span>
                )}
              </div>
            </div>
          ))}
          {data.rows.length > 6 && <p className="text-xs text-muted-foreground pt-2">+{data.rows.length - 6} nota lainnya di halaman Piutang</p>}
        </div>
      )}
    </Card>
  );
}
